import React from 'react';
import { Popover } from 'antd';
import { FormattedMessage } from 'react-intl';
import "./RejectTip.less";
export default ({ content, size, onClick, disabled }) => {
  if(!content) return null;
  return (
    <Popover content={
      <div>
        <p>{content}</p>
      </div>
    } title={<FormattedMessage id="audit_reject_tip_title"/>} trigger="hover">
      <i
        style={{ fontSize: size ? `${size}px` : `16px` }}
        className={`iconfont icon-tip reject-tip ${
          disabled ? 'icon-disabled' : ''
          } ${!disabled && onClick ? 'icon-pointer' : ''}`}
        onClick={onClick}
      />
    </Popover>
  );
};



// WEBPACK FOOTER //
// ./src/components/AuditManage/RejectTip.js